import React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { fetchRaceWithNumber } from "../../redux/getReducer/getRacewithNumber";
import { TiTick, TiTickOutline } from "react-icons/ti";
import Cookies from "js-cookie";
import { getRaceStatusColor } from "../../service/raceStatusColor";
// import "./RaceNumbersNew.css";

const RaceNumbers = ({ racecoursedata }) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userIsDesktop, setUserIsDesktop] = useState(true);
  const token = Cookies.get("token");

  const { data: RacewithNumber } = useSelector((state) => state.RacewithNumber);

  useEffect(() => {
    window.innerWidth > 840 ? setUserIsDesktop(true) : setUserIsDesktop(false);
  }, [userIsDesktop]);

  const raceHandler = (id) => {
    navigate(`/race-detail?${id}`);
  };

  const racecourseid = racecoursedata
    ? racecoursedata.RaceCourseData?._id
    : 1221;
  const Timing = racecoursedata?.StartTime;

  let datecalender = new Date(Timing);
  datecalender.setHours(0, 0, 0);
  const convertedDate = datecalender.toString();
  let newDate = new Date(convertedDate).toUTCString();

  useEffect(() => {
    dispatch(fetchRaceWithNumber({ racecourseid, newDate, token }));
  }, [dispatch, racecourseid, newDate, token]);

  const hexToRgba = (hex, opacity) => {
    if (!hex || !hex.startsWith("#")) return hex;
    let r = parseInt(hex.slice(1, 3), 16);
    let g = parseInt(hex.slice(3, 5), 16);
    let b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  return (
    <div className="my-new-racestatus-container">
      <ul className="my-new-race-list">
        {RacewithNumber
          ? RacewithNumber.map((item, index) => {
            const { RaceStatus } = item;
            const isActive = racecoursedata?.RaceNumber == item?.RaceNumber;
            const hasMultipleRaces = RacewithNumber.length > 1;
            const baseColor = getRaceStatusColor(RaceStatus, item);
            
            // If more than one race, inactive ones are dimmed (rgba with 0.3 opacity)
            // If only one race, or it is the active one, it gets the full color
            const finalBgColor = baseColor; 

            return (
              <li
                key={index}
                onClick={() => raceHandler(item._id)}
                className={`my-new-race-bubble ${isActive ? "my-new-active" : ""
                  }`}
                style={{
                  backgroundColor: finalBgColor, 
                  height: (hasMultipleRaces && isActive) ? "42px" : "34px", 
                  boxShadow: (hasMultipleRaces && isActive)
                    ? "rgba(0, 0, 0, 0.35) 0px 5px 15px"
                    : "none",
                  filter: (hasMultipleRaces && isActive) ? "brightness(1.3)" : "none",
                  border: (hasMultipleRaces && isActive) ? "1px solid rgba(255,255,255,0.5)" : "none"
                }}
              >
                {/* Voted Tick Logic preserved */}
                {item.IsCompetitionRace > 0 && (
                  <span className="my-new-checkvoted">
                    {item.Voted == 0 ? <TiTickOutline /> : <TiTick />}
                  </span>
                )}

                {/* Hardcoded 'R' before number */}
                <span className="my-new-race-text">R {item?.RaceNumber}</span>
              </li>
            );
          })
          : null}
      </ul>
    </div>
  );
};

export default RaceNumbers;
